import { useEffect } from 'react'
import { useAppStore } from '../store'

// Applies the persisted theme preference as a .dark class on <html>.
// Mounted in Layout so it only governs the app shell: landing pages,
// microsites and the print route render outside Layout and stay light.
export function useApplyTheme() {
  const theme = useAppStore(state => state.theme)

  useEffect(() => {
    const root = document.documentElement
    const media = window.matchMedia('(prefers-color-scheme: dark)')

    const apply = () => {
      const dark = theme === 'dark' || (theme === 'system' && media.matches)
      root.classList.toggle('dark', dark)
    }

    apply()

    if (theme === 'system') {
      media.addEventListener('change', apply)
      return () => {
        media.removeEventListener('change', apply)
        root.classList.remove('dark')
      }
    }

    return () => {
      root.classList.remove('dark')
    }
  }, [theme])
}
